import Page from "src/components/layouts/Page";
import css from "./TermsOfService.module.scss";

export default function TermsOfService(params) {
    return (
        <Page>
            <article className={css["article"]}>
                <div>
                    <h3>Agreement</h3>
                    <p>
                        Welcome to Livecart. THIS AGREEMENT IS BETWEEN YOU OR
                        THE ENTITY THAT YOU REPRESENT (hereinafter “You” or
                        “Your”) AND LIVECART INC (DBA/ LIVECART) GOVERNING YOUR
                        USE OF LIVECART.AI AND LIVECART SOFTWARE SERVICES AND
                        MOBILE APPLICATIONS. Livecart’s websites and all
                        corresponding mobile applications (collectively, the
                        “Sites”) are comprised of various web pages and mobile
                        applications operated by Livecart Inc (dba/ Livecart)
                        (“Livecart”). Livecart’s software services include any
                        application, service, and/or function, free or
                        purchased, provided to users by the Livecart Sites
                        (collectively, “Services”).
                    </p>
                </div>
                <div>
                    <h3>Parts of this Agreement</h3>
                    <p>
                        This Agreement consists of the following terms and
                        conditions (hereinafter the “General Terms”) and terms
                        and conditions, if any, specific to the use of
                        individual Services (hereinafter the “Service Specific
                        Terms”). The General Terms and Service Specific Terms
                        are collectively referred to as the “Terms”. In the
                        event of a conflict between the General Terms and
                        Service Specific Terms, the Service Specific Terms shall
                        prevail.
                    </p>
                </div>
                <div>
                    <h3>Acceptance of the Terms</h3>
                    <p>
                        The Sites are offered to you conditioned on your
                        acceptance without modification of the terms,
                        conditions, and notices contained here. Your use of the
                        Sites constitutes your agreement to all such Terms.
                        Please read these terms carefully, and keep a copy of
                        them for your reference. You must be of legal age to
                        enter into a binding agreement in order to accept the
                        Terms. If you do not agree to the General Terms, do not
                        use any of our Services. If you agree to the General
                        Terms and do not agree to any Service Specific Terms, do
                        not use the corresponding Service. You can accept the
                        Terms by checking a checkbox or clicking on a button
                        indicating your acceptance of the terms or by actually
                        using the Services.
                    </p>
                </div>

                <div>
                    <h3>Description of Services</h3>
                    <p>
                        The Sites are SaaS (Software-As-A-Service) websites and
                        applications. You may use the Services for your personal
                        and business use or for internal business purposes in
                        the organization that you represent. You may connect to
                        the Services using any Internet browser supported by the
                        Services. You are responsible for obtaining access to
                        the Internet and the equipment necessary to use the
                        Services. You can create and edit content with your user
                        account and if you choose to do so, you can publish and
                        share such content.
                    </p>
                </div>

                <div>
                    <h3> Privacy</h3>
                    <p>
                        Your use of the Sites and the personal information you
                        provide to Livecart through its Services is governed by
                        Livecart’ Privacy Policy. Your election to use the
                        Services indicates your acceptance of the terms of the
                        Livecart Inc. Privacy Policy. Please review our Privacy
                        Policy, which also governs the Sites and our Services
                        and informs users of our data collection practices.
                    </p>
                </div>

                <div>
                    <h3> Links to Third Party Sites/Third Party Services. </h3>
                    <p>
                        The Sites may contain links to other websites or
                        applications (“Linked Sites”). The Linked Sites are not
                        under the control of Livecart and Livecart is not
                        responsible for the contents of any Linked Sites,
                        including without limitation any link contained in a
                        Linked Site, or any changes or updates to a Linked Site.
                        Livecart is providing these links to you only as
                        convenience, and the inclusion of any link does not
                        imply endorsement by Livecart of the site or any
                        association with its operators.
                        <br />
                        Certain Services made available via the Sites are
                        delivered by third party sites and organizations. By
                        using any product, service or functionality originating
                        from the Sites, you hereby acknowledge and consent that
                        Livecart may share such information and data with any
                        third party with whom Livecart has a contractual
                        relationship to provide the requested product, service
                        or functionality on behalf of the Sites users and
                        customers.
                    </p>
                </div>

                <div>
                    <h3>Third Party Accounts</h3>
                    <p>
                        You will be able to connect your Livecart account to
                        third party accounts. By connecting your Livecart
                        account to your third party account, you acknowledge and
                        agree that you are consenting to the continuous release
                        of information about you to others (in accordance with
                        privacy settings on those third party sites). If you do
                        not want information about you to be shared in this
                        manner, do not use this feature.
                    </p>
                </div>

                <div>
                    <h3>Personal Information and Your Account</h3>
                    <p>
                        If you use our Sites and/or Services, you are
                        responsible for maintaining the Confidentiality of your
                        account and password and for restricting access to your
                        computer, and you agree to accept responsibility for all
                        activities that occur under your account and/or
                        password. You may not assign or otherwise transfer your
                        account to any other person or entity. You acknowledge
                        that Livecart is not responsible for third party access
                        to your account that results from theft or
                        misappropriation of your account. Livecart and its
                        associates reserve the right to refuse or cancel
                        service, terminate accounts, or remove or edit content
                        in our sole discretion. You are responsible for
                        maintaining confidentiality of your username, password
                        and other sensitive information. You are responsible for
                        all activities that occur in your user account and you
                        agree to inform us immediately of any unauthorized use
                        of your user account by email to support@livecart.ai or
                        by calling any of the numbers listed on Livecart's
                        Contact Page. We are not responsible for any loss or
                        damage to you or to any third party incurred as a result
                        of any unauthorized access and/or use of your user
                        account, or otherwise. Livecart does not knowingly
                        collect, either online or offline, personal information
                        from persons under the age of thirteen. If you are under
                        18, you may use the Sites only with permission of a
                        parent or guardian.
                    </p>
                </div>

                <div>
                    <h3>Use of Communication Services</h3>
                    <p>
                        The Sites may contain bulletin board services, chat
                        areas, news groups, forums, communities, personal web
                        pages, calendars, and/or other message or communication
                        facilities designed to enable you to communicate with
                        the public at large or with a group (collectively,
                        “Communication Services”), you agree to use the
                        Communication Services only to post, send and receive
                        messages and material that are proper and related to the
                        particular Communication Service.
                        <br />
                        By way of example, and not as a limitation, you agree
                        that when using a Communication Service, you will not:
                        defame, abuse, harass, stalk, threaten or otherwise
                        violate the legal rights (such as rights of privacy and
                        publicity) of others; public, post, upload, distribute
                        or disseminate any inappropriate, profane, defamatory,
                        infringing, obscene, indecent or unlawful topic, name,
                        material or information; upload files that contain
                        software or other material protected by intellectual
                        property laws (or by rights of privacy of publicity)
                        unless you own or control the rights thereto or have
                        received all necessary consents; upload files that
                        contain viruses, corrupted files, or any other similar
                        software or programs that may damage the operation of
                        another’s computer; advertise or offer to sell or buy
                        any goods or services for any business purpose, unless
                        such Communication Service specifically allows such
                        messages; conduct or forward surveys, contests, pyramid
                        schemes or chain letters; download any file posted by
                        another user of a Communication Service that you know,
                        or reasonably should know, cannot be legally distributed
                        in such manner, falsify or delete any author
                        attributions, legal or other proper notices or
                        proprietary designations or labels of the origin or
                        source of software or other material contained in a file
                        that is uploaded, restrict or inhibit any other user
                        from using and enjoying the Communication Services;
                        violate any code of conduct or other guidelines which
                        may be applicable for any particular Communication
                        Service; harvest or otherwise collect information about
                        others, including email addresses, without their
                        consent; violate any applicable laws or regulations.
                        Livecart has no obligation to monitor the Communication
                        Services. However, Livecart reserves the right to review
                        materials posted to a Communication Service and to
                        remove any materials in its sole discretion. Livecart
                        reserves the right to terminate your access to any or
                        all of the Communication Services at any time without
                        notice for any reason whatsoever.
                        <br />
                        Livecart reserves the right at all times to disclose any
                        information as necessary to satisfy any applicable law,
                        regulation, legal process or governmental request, or to
                        edit, refuse to post or to remove any information or
                        materials, in whole or in part, in Livecart’s sole
                        discretion.
                        <br />
                        Always use caution when giving out any personally
                        identifying information about yourself or your children
                        in any Communication Service. Livecart does not control
                        or endorse the content, message or information found in
                        any Communication Service, and therefore, Livecart
                        specifically disclaims any liability with regard to the
                        Communication Services and any actions resulting from
                        your participation in any Communication Service.
                        Managers and hosts are not authorized Livecart
                        spokespersons, and their views do not necessarily
                        reflect those of Livecart.
                        <br />
                        Materials uploaded to a Communication Service may be
                        subject to posted limitations on usage, reproduction
                        and/or dissemination. You are responsible for adhering
                        to such limitations if you upload the materials.
                    </p>
                </div>

                <div>
                    <h3>Electronic Communications</h3>
                    <p>
                        Visiting the Sites, using the Services and sending
                        emails to Livecart constitutes electronic communication.
                        You consent to receive electronic communications and you
                        agree that all agreements, notices, disclosures, and
                        other communications that we provide to you
                        electronically via email and on the Sites, satisfy any
                        legal requirement that such communications be in
                        writing. The Services may include certain communications
                        from Livecart, such as service announcements,
                        administration messages and newsletters. You understand
                        that their communications shall be considered part of
                        using the Services. As part of our policy to provide you
                        total privacy, we also provide you the option of opting
                        out from receiving newsletters from us. However, you
                        will not be able to opt-out from receiving service
                        announcements and administrative messages.
                    </p>
                </div>

                <div>
                    <h3>Cancellation/Refund Policy</h3>
                    <p>
                        Livecart strives to create and provide quality software
                        services that you enjoy using for your business and
                        professional life.
                        <br />
                        Monthly Subscription: If at any time during your first
                        month using any of the Livecart Services you are
                        dissatisfied, please contact us at support@livecart.ai.
                        We will do our best to address the issues and provide a
                        timely solution. If you are still not satisfied, we will
                        gladly offer you a FULL REFUND for your purchase, and if
                        you wish, we will downgrade your account to the free
                        plan for that service, if such free plan is offered at
                        the time.
                        <br />
                        Annual Subscription: If at any time during your first 45
                        days using any of the Livecart Services you are
                        dissatisfied, please contact us at support@livecart.ai.
                        We will do our best to address the issues and provide a
                        timely solution. If you are still not satisfied, we will
                        gladly offer you a FULL REFUND for your purchase, and if
                        you wish, we will downgrade your account to the free
                        plan for that service, if such free plan is offered at
                        the time.
                        <br />
                        Complete customer satisfaction is important to us. If at
                        any time during your contract we remove, break or
                        discontinue functionality that was available at the time
                        you signed up for your service contract, please contact
                        us immediately at support@livecart.ai. If we fail to
                        address the issue in a timely manner to your complete
                        satisfaction, we will offer you a PRORATED REFUND for
                        the remainder of your contract.
                        <br />
                        Auto-Renewal. Monthly and yearly subscriptions will
                        auto-renew until you cancel your service. Users have the
                        right to cancel their subscription at any time. Every
                        time your subscription auto-renews, we may or may not
                        send you a reminder email. After each auto-renewal, we
                        will also send a receipt specifying the amount that has
                        been deducted.
                        <br />
                        You can cancel your monthly/annual subscription up to
                        five days after your renewal date, and we will process
                        your cancellation and provide you a FULL REFUND.
                        <br />
                        Livecart reserves the right, in its sole discretion, to
                        refuse or cancel any or all services and terminate user
                        accounts at any time without a refund.
                        <br />
                        Please contact us at support@livecart.ai with any
                        questions about our Cancellation/Refund Policy.
                    </p>
                </div>

                <div>
                    <h3>Complaints</h3>
                    <p>
                        If we receive a complaint from any person against you
                        with respect to your activities as part of use of the
                        Services, we will forward the complaint to the primary
                        email address of your user account. You must respond to
                        the complainant directly to the primary email address of
                        your user account. You must respond to the complainant
                        directly within 10 days of receiving the complaint
                        forwarded by use and copy Livecart in the communication.
                        If you do not respond to the complainant within 10 days
                        from the date of our email to you, we may disclose your
                        name and contact information to the complainant for
                        enabling the complainant to take legal action against
                        you. You understand that your failure to respond to the
                        forwarded complaint within the 10 days’ time limit will
                        be construed as your disclosure of your name and contact
                        information by Livecart to the complainant.
                    </p>
                </div>

                <div>
                    <h3>Subscription to Beta Service</h3>
                    <p>
                        We may offer certain Services as closed or open beta
                        services (“Beta Service” or “Beta Services”) for the
                        purpose of testing and evaluation. You agree that we
                        have the sole authority and discretion to determine the
                        period of time for testing and evaluation of Beta
                        Services. We will be the sole judge of the success of
                        such testing and the decision, if any, to offer the Beta
                        Services as commercial services. You will be under no
                        obligation to acquire a subscription to use any paid
                        Service as a result of your subscription to any Beta
                        Service. We reserve the right to fully or partially
                        discontinue, at any time and from time to time,
                        temporarily or permanently, any of the Beta Services
                        with or without notice to you. You agree that Livecart
                        will not be liable to you or to any third party for any
                        harm related to, arising out of, or caused by the
                        modification, suspension or discontinuance of any of the
                        Beta Services for any reason.
                    </p>
                </div>

                <div>
                    <h3>Modification of Terms of Service</h3>
                    <p>
                        Livecart reserves the right, in its sole discretion, to
                        change the Terms under which the Sites and Services are
                        offered. The most current version of the Terms will
                        supersede all previous versions. Livecart encourages you
                        to periodically review the Terms to stay informed of our
                        updates.
                    </p>
                </div>

                <div>
                    <h3>User Signup Obligations</h3>
                    <p>
                        You need to sign up for a user account by providing all
                        required information in order to access or use the
                        Services. If you represent an organization and wish to
                        use the Services for corporate internal use, we
                        recommend that you, and all other users from your
                        organization, sign up for user accounts by providing
                        your corporate contact information. In particular, we
                        recommend that you use your corporate email address. You
                        agree to:
                        <br />
                        a) provide true, accurate, current and complete
                        information about yourself as prompted by the signup
                        process; and
                        <br />
                        b) maintain and promptly update the information provided
                        during signup to keep it true, accurate, current, and
                        complete. If you provide any information that is untrue,
                        inaccurate, outdated, or incomplete, or if Livecart has
                        reasonable grounds to suspect that such information is
                        untrue, inaccurate, outdated, or incomplete, Livecart
                        may terminate your user account and refuse current or
                        future use of any or all of the Services.
                    </p>
                </div>

                <div>
                    <h3>Organization Accounts and Administrators</h3>
                    <p>
                        When you sign up for an account for your organization
                        you are assumed to be an administrator. The
                        administrators will have the right to configure the
                        Services based on your organization’s requirements and
                        manage end users in your organization account. If your
                        organization account is created and configured on your
                        behalf by a third party, it is likely that such third
                        party has assumed administrator role for your
                        organization. Make sure that you enter into a suitable
                        agreement with such third party specifying such party’s
                        roles and restrictions as an administrator of your
                        organization account. You are responsible for a)
                        ensuring confidentiality of your organization account
                        password, b) appointing competent individuals as
                        administrators for managing your organization account,
                        and c) ensuring that all activities that occur in
                        connection with your organization account comply with
                        this Agreement. You understand that Livecart is not
                        responsible for account administration and internal
                        management of the Services for you. You are responsible
                        for taking necessary steps for ensuring that your
                        organization does not lose control of the administrator
                        accounts. You may specify a process to be followed for
                        recovering control in the event of such loss of control
                        of the administrator accounts by sending an email to
                        support@livecart.ai, provided that the process is
                        acceptable to Livecart. In the absence of any specified
                        administrator account recovery process, Livecart may
                        provide control of an administrator account to an
                        individual providing proof satisfactory to Livecart
                        demonstrating authorization to act on behalf of the
                        organization. You agree not to hold Livecart liable for
                        the consequences of any action taken by Livecart in good
                        faith in this regard.
                    </p>
                </div>

                <div>
                    <h3>Fees and Payments</h3>
                    <p>
                        The Services are available under subscription plans of
                        various durations. Payments for subscription plans of
                        duration of less than a year can be made only by Credit
                        Card. Your subscription will be automatically renewed at
                        the end of each subscription period unless you downgrade
                        your paid subscription plan to a free plan or inform us
                        that you do not wish to renew the subscription. At the
                        time of automatic renewal, the subscription fee will be
                        charged to the Credit Card last used by you. We provide
                        you the option of changing the details if you would like
                        the payment for the renewal to be made through a
                        different Credit Card. If you do not wish to renew the
                        subscription, you must inform us at least seven days
                        prior to the renewal date. If you have not downgraded to
                        a free plan and if you have not informed us that you do
                        not wish to renew the subscription, you will be presumed
                        to have authorized Livecart to charge the subscription
                        fee to the Credit Card last used by you. Please click
                        here to know about our Refund/Cancellation Policy. From
                        time to time, we may change the price of any Service or
                        charge for use of the Services that are currently
                        available free of charge. Any increase in charges will
                        not apply until the expiry of your then current billing
                        cycle. You will not be charged for using any Service
                        unless you have opted for a paid subscription plan.
                    </p>
                </div>

                <div>
                    <h3>International Users</h3>
                    <p>
                        This Service is controlled, operated and administered by
                        Livecart from our offices within the United States of
                        America. If you access the Service from a location
                        outside of the United States of America, you are
                        responsible for compliance with all local laws. You
                        agree that you will not use the Livecart content
                        accessed through the Sites in any country or in any
                        manner prohibited by any applicable laws, restrictions
                        or regulations.
                    </p>
                </div>
                <div>
                    <h3>Restrictions on Use</h3>
                    <p>
                        In addition to all other terms and conditions of this
                        Agreement, you shall not: (i) transfer the Services or
                        otherwise make it available to any third party; (ii)
                        provide any service based on the Services without prior
                        written permission; (iii) use the third party links to
                        sites without agreeing to their website terms &
                        conditions; (iv) post links to third party sites or use
                        their logo, company name, etc. without their prior
                        written permission; (v) publish any personal or
                        confidential information belonging to any person or
                        entity without obtaining consent from such person or
                        entity; (vi) use the Services in any manner that could
                        damage, disable, overburden, impair or harm and server,
                        network, computer system, resource of Livecart; (vii)
                        violate any applicable local, state, national or
                        international law; and (viii) create a false identity to
                        mislead any person as to the identity or origin of any
                        communication.
                    </p>
                </div>
                <div>
                    <h3>
                        Materials Provided to the Sites or Posted on any
                        Livecart Web Page
                    </h3>
                    <p>
                        Livecart does not claim ownership of the materials you
                        provide to the Sites (including feedback and
                        suggestions) or post, upload, input or submit to any
                        Livecart Site or our associated services (collectively,
                        “Submissions”). However, by posting, uploading,
                        inputting, providing or submitting your Submission you
                        are granting Livecart, our affiliated companies and
                        necessary sublicensees permission to use your Submission
                        in connection with the operation of their Internet
                        businesses including, without limitation, the rights to:
                        copy, distribute, transmit, publicly display, publicly
                        perform, reproduce, edit, translate and reformat your
                        Submission; and to publish your name in connection with
                        your Submission.
                        <br />
                        No Compensation will be paid with respect to the use of
                        your Submission, as provided herein. Livecart is under
                        no obligation to post or use any Submission you may
                        provide and may remove any Submission at any time in
                        Livecart’s sole discretion.
                    </p>
                </div>
                <div>
                    <h3>Spamming and Illegal Activities</h3>
                    <p>
                        You agree to be solely responsible for the contents of
                        your transmissions through the Services. You agree not
                        to use the Services for illegal purposes or for the
                        transmission of material that is unlawful, defamatory,
                        harassing, libelous, invasive of another’s privacy,
                        abusive, threatening, harmful, vulgar, pornographic,
                        obscene, or is otherwise objectionable, offends
                        religious sentiments, promotes racism, contains viruses
                        or malicious code, or that which infringes or may
                        infringe intellectual property or other rights of
                        another. You agree not to use the Services for the
                        transmission of “junk mail”, “spam”, “chain letters”,
                        “phishing” or unsolicited mass distribution of email. We
                        reserve the right to terminate your access to the
                        Services if there are reasonable grounds to believe that
                        you have used the Services for any illegal or
                        unauthorized activity.
                    </p>
                </div>
                <div>
                    <h3>Inactive User Accounts Policy</h3>
                    <p>
                        We reserve the right to terminate unpaid user accounts
                        that are inactive for a continuous period of fourteen
                        (14) days. In the event of such termination, all data
                        associated with such a user account may be deleted or
                        stored without recourse. We will provide you prior
                        notice of such termination. The Data Deletion/Retention
                        Policy (see below) may be implemented with respect to
                        any or all of the Services. Each Service will be
                        considered an independent and separate service for the
                        purpose of calculating the period of inactivity. In
                        other words, activity in one of the Services is not
                        sufficient to keep your user account in another Service
                        active. In case of accounts with more than one user, if
                        at least one of the users is active, the account will
                        not be considered inactive.
                    </p>
                </div>
                <div>
                    <h3>Data Deletion/Retention Policy</h3>
                    <p>
                        Livecart may retain all user information and data
                        indefinitely, regardless of account or subscription
                        payment status. In the case of account termination or
                        deletion by Livecart or the user, all user information
                        and data, with respect to any or all of the Services,
                        may be deleted or stored for Livecart’s internal use and
                        will not be accessible to the user.
                    </p>
                </div>
                <div>
                    <h3>Data Ownership</h3>
                    <p>
                        We respect your right to ownership of content created or
                        stored by you. You own the content created or stored by
                        you. Unless specifically permitted by you, your use of
                        the Services does not grant Livecart the license to use,
                        reproduce, adapt, modify, publish or distribute the
                        content created by you or stored in your user account
                        for Livecart’s commercial, marketing or any similar
                        purpose. But you grant Livecart permission to access,
                        copy, distribute, store, transmit, reformat, publicly
                        display and publicly perform the content of your user
                        account solely as required for the purpose of providing
                        the Services to you.
                    </p>
                </div>
                <div>
                    <h3>User Generated Content</h3>
                    <p>
                        You may transmit or publish content created by you using
                        any of the Services or otherwise. However, you shall be
                        solely responsible for such content and the consequences
                        of its transmission or publication. Any content made
                        public will be publicly accessible through the internet
                        and may be crawled and indexed by search engines. You
                        are responsible for ensuring that you do not
                        accidentally make any private content publicly
                        available. Any content that you may receive from other
                        users of the Services, is provided to you AS IS for your
                        information and personal use only and you agree not to
                        use, copy, reproduce, distribute, transmit, broadcast,
                        display, sell, license or otherwise exploit such content
                        for any purpose, without the express written consent of
                        the person who owns the rights to such content. In the
                        course of using any of the Services, if you come across
                        any content with copyright notice(s) or any copy
                        protection feature(s), you agree not to remove such
                        copyright notice(s) or disable such copy protection
                        feature(s) as the case may be. By making any
                        copyrighted/copyrightable content available on any of
                        the Services you affirm that you have the consent,
                        authorization or permission, as the case may be from
                        every person who may claim any rights in such content to
                        make such content available in such manner. Further, by
                        making any content available in the manner
                        aforementioned, you expressly agree that Livecart will
                        have the right to block access to or remove such content
                        made available by you if Livecart receives complaints
                        concerning any illegality or infringement of third party
                        rights in such content. By using any of the Services and
                        transmitting or publishing any content using such
                        Service, you expressly consent to determination of
                        questions of illegality or infringement of third party
                        rights in such content by the agent designated by
                        Livecart for this purpose. For procedures relating to
                        complaints of illegality or infringement of third party
                        rights in content transmitted or published using the
                        Services, please email support@livecart.ai. If you wish
                        to protest any blocking or removal of content by
                        Livecart, you may do so in the manner provided here.
                    </p>
                </div>
                <div>
                    <h3>Sample Files and Application</h3>
                    <p>
                        Livecart may provide sample files and applications for
                        the purpose of demonstrating the possibility of using
                        the Services effectively for specific purposes. The
                        information contained in any such sample files and
                        applications consists of random data. Livecart makes no
                        warranty, either express or implied, as to the accuracy,
                        usefulness, completeness or reliability of the
                        information or the samples files and applications.
                    </p>
                </div>
                <div>
                    <h3>No Unlawful or Prohibited Use/Intellectual Property</h3>
                    <p>
                        You are granted a non-exclusive, non-transferable,
                        revocable license to access and use the Sites strictly
                        in accordance with these terms of use. As a condition of
                        your use of the Sites, you warrant to Livecart that you
                        will not use the Sites for any purpose that is unlawful
                        or prohibited by these Terms. You may not use the Sites
                        in any manner which could damage, disable, overburden,
                        or impair the Site or interfere with any other party’s
                        use and enjoyment of the Sites. You may not obtain or
                        attempt to obtain any materials or information through
                        any means not intentionally made available or provided
                        for through the Sites.
                        <br />
                        Livecart, Livecart logo, the names of individual
                        Services, and their logos are trademarks of Livecart
                        Inc.. You agree not to display or use, in any manner,
                        the Livecart trademarks, without Livecart’s prior
                        written consent. All content included as part of the
                        Service, such as text, graphics, logos, images, as well
                        as compilation thereof, and any software used on the
                        Sites, is the property of Livecart or its suppliers and
                        protected by copyright, trademark and other laws that
                        protect intellectual property and proprietary rights.
                        You agree to observe and abide by all copyright and
                        other proprietary notices, legends or other restrictions
                        contained in any such content and will not make any
                        changes thereto.
                        <br />
                        You will not modify, publish, transmit, reverse
                        engineer, participate in the transfer or sale, create
                        derivative works, or in any way exploit any of the
                        content, in whole or in part, found on the Sites.
                        Livecart content is not for resale. You use of the Sites
                        do not entitle you to make any unauthorized use of any
                        protected content, and in particular you will not delete
                        or alter any proprietary rights or attribution notices
                        in any content You will use protected content solely for
                        your personal use, and will make no other use of the
                        content without the express written permission of
                        Livecart and the copyright owner. You agree that you do
                        not acquire any ownership rights in any protected
                        content. We do not grant you any licenses express or
                        implied, to the intellectual property of Livecart or our
                        licensors except as expressly authorized by these Terms.
                    </p>
                </div>
                <div>
                    <h3>Disclaimer of Warranties</h3>
                    <p>
                        YOU EXPRESSLY UNDERSTAND AND AGREE THAT THE USE OF THE
                        SERVICES IS AT YOUR SOLE RISK. THE SERVICES ARE PROVIDED
                        ON AN AS-IS-AND-AS-AVAILABLE BASIS. LIVECART EXPRESSLY
                        DISCLAIMS ALL WARRANTIES OF ANY KING, WHETHER EXPRESS OR
                        IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                        WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
                        PARTICULAR PURPOSE. LIVECART MAKES NOT WARRANTY THAT
                        THEY SERVICES WILL BE UNINTERRUPTED, TIMELY, SECURE, OR
                        ERROR FREE. USE OF ANY MATERIAL DOWNLOADED OR OBTAINED
                        THROUGH THE USE OF THE SERVICES SHALL BE AT YOUR OWN
                        DISCRETION AND RISK AND YOU WILL BE SOLELY RESPONSIBLE
                        FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM, MOBILE
                        TELEPHONE, WIRELESS DEVICE OR DATA THAT RESULTS FROM THE
                        USE OF THE SERVICES OR THE DOWNLOAD OF ANY SUCH
                        MATERIALS. NO ADVICE OR INFORMATION, WHETHER WRITTEN OR
                        ORAL, OBTAINED BY YOU FROM LIVECART, ITS EMPLOYEES OR
                        REPRESENTATIVES SHALL CREATE ANY WARRANTY NOT EXPRESSLY
                        STATED IN THE TERMS.
                    </p>
                </div>
                <div>
                    <h3>Liability Disclaimer</h3>
                    <p>
                        THE INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES
                        INCLUDED IN OR AVAILABLE THROUGH THE SITE MAY INCLUDE
                        INACCURACIES OR TYPOGRAPHICAL ERRORS. CHANGES ARE
                        PERIODICALLY ADDED TO THE INFORMATION HEREIN. VIEUER LLC
                        (DBA/ LIVECART) AND/OR ITS SUPPLIERS MAY MAKE
                        IMPROVEMENTS AND/OR CHANGES IN THE SITE AT ANY TIME.
                        <br />
                        VIEUER LLC (DBA/ LIVECART) AND/OR ITS SUPPLIERS MAKE NO
                        REPRESENTATIONS ABOUT THE SUITABILITY, RELIABILITY,
                        AVAILABILITY, TIMELINESS, AND ACCURACY OF THE
                        INFORMATION, SOFTWARE, PRODUCTS, SERVICES AND RELATED
                        GRAPHICS CONTAINED ON THE SITE FOR ANY PURPOSE. TO THE
                        MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, ALL SUCH
                        INFORMATION, SOFTWARE, PRODUCTS, SERVICES AND RELATED
                        GRAPHICS ARE PROVIDED “AS IS” WITHOUT WARRANTY OR
                        CONDITION OF ANY KIND. VIEUER LLC (DBA/ LIVECART) AND/OR
                        ITS SUPPLIERS HEREBY DISCLAIM ALL WARRANTIES AND
                        CONDITIONS WITH REGARD TO THE INFORMATION, SOFTWARE,
                        PRODUCTS, SERVICES AND RELATED GRAPHICS, INCLUDING ALL
                        IMPLIED WARRANTIES OR CONDITIONS OR MERCHANTABILITY,
                        FITNESS FOR A PARTICULAR PURPOSE, TITLE AND
                        NON-INFRINGEMENT.
                        <br />
                        TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, YOU
                        AGREE THAT IN NO EVENT SHALL VIEUER LLC (DBA/ LIVECART)
                        AND/OR ITS SUPPLIERS BE LIABLE FOR ANY DIRECT, INDIRECT,
                        PUNITIVE, INCIDENTAL, SPECIAL, CONSEQUENTIAL DAMAGES OR
                        ANY OTHER LOSS OR DAMAGES WHATSOEVER INCLUDING, WITHOUT
                        LIMITATION, DAMAGES FOR LOSS OF USE, LOSS OF BUSINESS
                        PROFITS, BUSINESS INTERRUPTION, COMPUTER FAILURE, LOSS
                        OF BUSINESS INFORMATION, LOSS OF DATA OR PROFITS, OR
                        OTHER LOSS ARISING OUT OF OR IN ANY WAY CONNECTED WITH
                        THE USE OR PERFORMANCE OF THE SITES OR SERVICES, WITH
                        THE DELAY OR INABILITY TO USE THE SITE OR RELATED
                        SERVICES, THE PROVISION OF OR FAILURE TO PROVIDE
                        SERVICES, OR FOR ANY INFORMATION, SOFTWARE, PRODUCTS,
                        SERVICES AND RELATED GRAPHICS OBTAINED THROUGH THE SITE,
                        OR OTHERWISE ARISING OUT OF THE USE OF THE SITE, WHETHER
                        BASED ON CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY OR
                        OTHERWISE, EVEN IF VIEUER LLC (DBA/ LIVECART) OR ANY OF
                        ITS SUPPLIERS HAS BEEN ADVISED OF THE POSSIBILITY OF
                        DAMAGES. BECAUSE SOME STATES/JURISDICTIONS DO NOT ALLOW
                        THE EXCLUSION OR LIMITATION OF LIABILITY FOR
                        CONSEQUENTIAL OR INCIDENTAL DAMAGES, THE ABOVE
                        LIMITATION MAY NOT APPLY TO YOU. IF YOU ARE DISSATISFIED
                        WITH ANY PORTION OF THE SITE, OR WITH ANY OF THESE TERMS
                        OF USE, YOUR SOLE AND EXCLUSIVE REMEDY IS TO DISCONTINUE
                        USING THE SITE. IN NO EVENT SHALL LIVECART’S ENTIRE
                        LIABILITY TO YOU IN RESPECT OF ANY SERVICE, WHETHER
                        DIRECT OR INDIRECT, EXCEED THE FEES PAID BY YOU TOWARDS
                        SUCH SERVICE.
                    </p>
                </div>
                <div>
                    <h3>Indemnification</h3>
                    <p>
                        You agree to indemnify, defend and hold harmless
                        Livecart, its officers, directors, employees, agents,
                        suppliers, affiliates and third parties from and against
                        any losses, costs, liabilities, damages, fines and
                        expenses (including reasonable attorney’s fees and
                        costs) relating to or arising out of your use of or
                        inability to use the Site or Services (except where such
                        use is authorized by Livecart), any user postings made
                        by you, your violation of any terms of this Agreement or
                        your violation of any rights of a third party, or your
                        violation of any applicable laws, rules or regulations.
                        Livecart reserves the right, at its own cost, to assume
                        the exclusive defense and control of any matter
                        otherwise subject to indemnification by you, in which
                        even you will fully cooperate with Livecart in asserting
                        any available defenses.
                    </p>
                </div>
                <div>
                    <h3>Arbitration</h3>
                    <p>
                        In the event the parties are not able to resolve any
                        dispute or claim between them arising out of or
                        concerning the Terms and Conditions, or any provisions
                        hereof, whether in contract, tort, or otherwise at law
                        or in equity for damages or any other relief, then such
                        dispute shall be resolved only by final and binding
                        arbitration pursuant to the Federal Arbitration Act,
                        conducted by a single neutral arbitrator and
                        administered by the American Arbitration Association, or
                        a similar arbitration service selected by the parties.
                        All arbitrations shall be conducted in the state of
                        Maryland. Any such dispute or claim shall be arbitrated
                        on an individual basis, and shall not be consolidated in
                        any arbitration with any dispute or claim of any other
                        party. The decision of the arbitrator shall be final and
                        unappealable, and judgement on the arbitration award may
                        be entered into any court having jurisdiction thereof.
                        In the event that any legal or equitable action,
                        proceeding or arbitration arises out of or concerns
                        their Terms and Conditions, the prevailing party shall
                        be entitled to recover its costs and reasonable attorney
                        fees. The parties agree to arbitrate all disputes and
                        claims in regards to these Terms and Conditions or any
                        disputes arising as a result of these Terms and
                        Conditions, whether directly or indirectly, including
                        tort claims that are a result of these Terms and
                        Conditions. The parties agree that the Federal
                        Arbitration Act governs the interpretation and
                        enforcement of this provision. The entire dispute,
                        including the scope and enforceability of this
                        arbitration provision shall be determined by the
                        Arbitrator. This arbitration provision shall survive the
                        termination of these Terms and Conditions.
                        Notwithstanding anything to the contrary, Livecart may
                        at any time seek injunctions or other forms of equitable
                        relief from any court of competent jurisdiction.
                    </p>
                </div>

                <div>
                    <h3>Class Action Waiver</h3>
                    <p>
                        Any arbitration under these Terms and Conditions will
                        take place on an individual basis; class arbitrations
                        and class; representative/collective actions are not
                        permitted. THE PARTIES AGREE THAT A PARTY MAY BRING
                        CLAIMS AGAINST THE OTHER ONLY IN EACH INDIVIDUAL
                        CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY
                        PUTATIVE CLASS, COLLECTIVE AND/OR REPRESENTATIVE
                        PROCEEDING, SUCH AS IN THE FORM OF A PRIVATE ATTORNEY
                        GENERAL ACTION AGAINST THE OTHER. Further, unless both
                        you and Employer agree otherwise, the arbitrator may not
                        consolidate more than one person’s claims, and may not
                        otherwise preside over any form of a representative or
                        class proceeding.
                    </p>
                </div>

                <div>
                    <h3>Suspension/Termination/Access Restriction</h3>
                    <p>
                        Livecart reserves the right, in its sole discretion, to
                        terminate your access to the Site and the related
                        Services or any portion thereof at any time, without
                        notice. We may suspend your user account or temporarily
                        disable access to the whole or part of any Service in
                        the event of any suspected illegal activity, extended
                        periods of inactivity or requests by law enforcement or
                        other government agencies. Objections to suspension or
                        disabling of user accounts should be made to
                        support@livecart.ai within thirty days of being notified
                        about the suspension. We may terminate a suspended or
                        disabled user account after thirty (30) days. We will
                        also terminate your user account on your request. In
                        addition, we reserve the right to terminate your user
                        account and deny the Services upon reasonable belief
                        that you have violated the Terms and to terminate your
                        access to any Beta Service in case of unexpected
                        technical issues or discontinuation of the Beta Service.
                        You have the right to terminate your user account if
                        Livecart breaches its obligations under these Terms and
                        in such event, you will be entitled to prorated refund
                        of any prepaid fees. Termination of user accounts will
                        include denial of user access to all Services, and
                        Livecart reserves the right in its sole discretion to
                        delete or store all user information and data for
                        internal use. To the maximum extent permitted by law,
                        this agreement is governed by the laws of the State of
                        Maryland and you hereby consent to the exclusive
                        jurisdiction and venue of courts in Maryland in all
                        disputes arising out of or relating to the use of the
                        Site and/or Services. Use of the Site and Services is
                        unauthorized in any jurisdiction that does not give
                        effect to all provisions of these Terms, including,
                        without limitation, this section.
                        <br />
                        You agree that no joint venture, partnership,
                        employment, or agency relationship exists between you
                        and Livecart as a result of this agreement or use of the
                        Site. Livecart’s performance of this agreement is
                        subject to existing laws and legal process, and nothing
                        contained in this agreement is in derogation of
                        Livecart’s right to comply with governmental, court and
                        law enforcement requests or requirements relating to
                        your use of the Site or information provided to or
                        gathered by Livecart with respect to such use. If any
                        part of this agreement is determined to be invalid or
                        unenforceable pursuant to applicable law including, but
                        not limited to, the warranty disclaimers and liability
                        limitations set forth above, then the invalid or
                        unenforceable provision will be deemed superseded by a
                        valid, enforceable provision that most closely matches
                        the intent of the original provision and the remainder
                        of the agreement shall continue in effect.
                        <br />
                        Unless otherwise specified herein, this agreement
                        constitutes the entire agreement between the use and
                        Livecart with respect to the Site and it supersedes all
                        prior or contemporaneous communications and proposals,
                        whether electronic, oral or written, between the user
                        and Livecart with respect to the Site. A printed version
                        of this agreement and of any notice given in electronic
                        form shall be admissible in judicial or administrative
                        proceedings based upon or relating to this agreement to
                        the same extent and subject to the same conditions as
                        other business documents and records originally
                        generated and maintained in printed form. It is the
                        express wish to the parties that this agreement and all
                        related documents be written in English.
                        <br />
                        <strong>End of Terms of Service/Contact Us.</strong>
                    </p>
                </div>
                <div>
                    If you have any questions or concerns regarding this
                    Agreement or the Terms, please contact us:
                    <table className={css["table"]}>
                        <tbody>
                            <tr>
                                <td>Postal Address:</td>
                                <td>
                                    <address>
                                        Vieuer LLC (dba/ Livecart)
                                        <br />
                                        1775 Tysons Blvd, 5th Floor
                                        <br />
                                        McLean, VA 22012
                                    </address>
                                </td>
                            </tr>
                            <tr>
                                <td>Email:</td>
                                <td>
                                    <a href="mailto:support@livecart.ai">
                                        support@livecart.ai
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>Telephone:</td>
                                <td>
                                    <a href="tel:855-505-LIVE (5483)">
                                        855-505-LIVE (5483)
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </article>
        </Page>
    );
}
